import ReassignResultDialog from "./reassign-result.container";

export default ReassignResultDialog;
